import { render, staticRenderFns } from "./roomBook.vue?vue&type=template&id=20a9e6d1&"
import script from "./roomBook.vue?vue&type=script&lang=js&"
export * from "./roomBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports